import PolicyPDF from "../components/PolicyPDF";
import "../css/policy.css";

const faqs = [
  {
    question: "What printing services does IGC Print Press provide?",
    answer:
      "We provide commercial and creative printing services, including printed materials, branding materials, packaging, promotional materials, and other print-related services.",
  },
  {
    question: "How do I request a quote?",
    answer:
      "You can submit a quote request through the Request a Quote page on our website. Provide the required details, specifications, and artwork where applicable, and our team can review the request.",
  },
  {
    question: "Can I provide my own artwork?",
    answer:
      "Yes. Customers can provide their own artwork where applicable. Supported file formats and upload requirements are displayed on the quote request form.",
  },
  {
    question: "Can I ask IGC Print Press to design my artwork?",
    answer:
      "Yes. Design assistance can be requested where available. The cost and scope of the design service will depend on the requirements of the project.",
  },
  {
    question: "When does production begin?",
    answer:
      "Production generally begins after the required payment or deposit has been received and the necessary artwork or specifications have been confirmed.",
  },
  {
    question: "Can I cancel my order?",
    answer:
      "Cancellation requests should be made as early as possible. Once production has started, cancellation may not be possible or may result in costs associated with work and materials already committed.",
  },
  {
    question: "How long does printing take?",
    answer:
      "Production time varies depending on the type, quantity, materials, finishing requirements, artwork readiness, and current production schedule. The applicable timeline will be communicated for your order.",
  },
  {
    question: "Do you offer delivery?",
    answer:
      "Delivery may be available depending on the order and destination. Customers can also arrange or select collection where applicable.",
  },
  {
    question: "Can I collect my completed order?",
    answer:
      "Yes. Where collection is available, customers can collect completed orders from our pressroom at CBU Mall, Igwuruta, Along Eneka Road, Port Harcourt.",
  },
  {
    question: "What happens if there is a problem with my order?",
    answer:
      "Contact IGC Print Press as soon as possible with your order details and a description of the issue. We will review the matter and determine the appropriate resolution.",
  },
  {
    question: "Can I get a refund?",
    answer:
      "Refunds depend on the status of the order and the reason for the request. Please refer to our Refund Policy for more information.",
  },
  {
    question: "How can I contact IGC Print Press?",
    answer:
      "You can contact us on +234 803 773 8028 or use the contact options provided on our website.",
  },
];

export default function FAQs() {
  return (
    <div className="policy-page">
      <div className="wrap">
        <div className="policy-hero">
          <span className="hero-tag">
            <span className="pulse" />
            IGC PRINT PRESS
          </span>

          <h1 className="policy-title">
            Frequently Asked Questions
          </h1>

          <p className="policy-intro">
            Answers to common questions about our printing services,
            quotes, artwork, production, delivery, payments, and orders.
          </p>
        </div>

        <PolicyPDF
          title="Frequently Asked Questions"
          filename="IGC-Print-Press-FAQs.pdf"
          faqs={faqs}
        >
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div className="faq-item" key={faq.question}>
                <span className="faq-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <div>
                  <h2>{faq.question}</h2>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </PolicyPDF>
      </div>
    </div>
  );
}